<script>
import RestList from '@/common/components/rest/RestList.vue'
import RestListColumn from '@/common/components/rest/RestListColumn.vue'
import RestListColumnBoolean from '@/common/components/rest/RestListColumnBoolean.vue'
import RestListColumnDate from '@/common/components/rest/RestListColumnDate.vue'
import RestListColumnEnum from '@/common/components/rest/RestListColumnEnum.vue'
import { projectEndpoint, projectRoute } from '@/core/helpers'
import { profileIdentifiersLabels } from '@/modules/profiles/enum/ProfileIdentifiersEnum'

export default {
  components: {
    RestListColumnEnum,
    RestListColumnDate,
    RestListColumnBoolean,
    RestList,
    RestListColumn
  },

  data() {
    return {
      profileIdentifiersLabels
    }
  },

  computed: {
    fetchEndpoint() {
      return projectEndpoint({
        method: 'get',
        url: `integrations/otp/${this.$route.query.id}/history`,
        params: {
          sort: '-request_ts'
        }
      })
    },
    isEngageHubEnabled() {
      return this.$store.state.app.project.gateway.channel === 'engage_hub'
    }
  },

  methods: {
    rowClickProfileIdRoute(row) {
      if (!row.profile_id) {
        return null
      }

      return projectRoute({
        name: 'ProfileOverview',
        query: { profile_id: row.profile_id }
      })
    }
  }
}
</script>

<template>
  <rest-list :payload="fetchEndpoint" ref="otp-history-list">
    <template slot="default">
      <rest-list-column
        prop="profile_id"
        :title="$t('Integrations_Otp_History_Field_ProfileId')"
        :min-width="100"
        :fixed="true"
      >
        <template slot-scope="{ row }">
          <div class="id-cell">
            <el-tooltip
              effect="light"
              placement="top"
              :content="row.profile_id"
              v-if="row.profile_id"
            >
              <router-link :to="rowClickProfileIdRoute(row)" class="user-link">
                <icon glyph="user-profile" class="user-profile-icon" />
              </router-link>
            </el-tooltip>
            <span v-else>-</span>
          </div>
        </template>
      </rest-list-column>
      <rest-list-column-date
        prop="request_ts"
        :title="$t('Integrations_Otp_History_Field_RequestTs')"
        :min-width="200"
        :unix="false"
        :fixed="true"
      />
      <rest-list-column
        prop="otp_id"
        :title="$t('Integrations_Otp_History_Field_OtpId')"
        :min-width="340"
      />
      <rest-list-column-enum
        prop="identifier"
        :enum="profileIdentifiersLabels"
        :title="$t('Integrations_Otp_History_Field_IdentifierType')"
        :min-width="160"
      />
      <rest-list-column
        prop="identifier_value"
        :title="$t('Integrations_Otp_History_Field_IdentifierValue')"
        :min-width="300"
        :filterable="false"
        :sortable="false"
      />
      <rest-list-column
        prop="mobile_number"
        :title="$t('Integrations_Otp_History_Field_MobileNumber')"
        :min-width="200"
      />
      <rest-list-column-boolean
        prop="sent"
        :title="$t('Integrations_Otp_History_Field_Sent')"
        :min-width="120"
      />
      <rest-list-column-boolean
        v-if="isEngageHubEnabled"
        prop="sim_swap_check"
        :sortable="false"
        :filterable="false"
        :title="$t('Integrations_Otp_History_Field_SimSwap')"
        :min-width="120"
      />
      <rest-list-column-boolean
        prop="delivered"
        :title="$t('Integrations_Otp_History_Field_Delivered')"
        :min-width="120"
      />
      <rest-list-column-date
        prop="verified_ts"
        :title="$t('Integrations_Otp_History_Field_VerifiedTs')"
        :min-width="200"
        :unix="false"
      />
      <rest-list-column
        prop="error"
        :title="$t('Integrations_Otp_History_Field_Error')"
        :min-width="300"
      />
    </template>
  </rest-list>
</template>

<style scoped>
.user-link {
  text-decoration: none !important;
}
.user-profile-icon {
  font-size: large;
  top: 3px;
  position: relative;
  color: #1d87c9;
}
.user-profile-icon:hover {
  color: #176ca1;
}
.id-cell {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/modules/integrations/types/otp/OtpHistory.vue